import {BaseResource} from "./Resource";

export class BaseSignableDocuments extends BaseResource
{
    constructor(resource_name) {
        super()
        this.handle = 'signable-' + resource_name + '-docs'
        this.resourceSegments = [resource_name, null, 'signable-documents'];
    }

    forModel(model_id) {
        this.resourceSegments[1] = model_id
        return this
    }

    all() {
        return this._doGet([]);
    }

    show(document_type) {
        return this._doGet([document_type])
    }

    requestSigning(document_type, request_type) {
        return this._doPost(['signing-requests'], { document_type, request_type })
    }

    showSigningRequest(request_id) {
        return this._doGet(['signing-requests', request_id])
    }

    cancelSigning(request_id) {
        return this._doPut(['signing-requests', request_id, 'cancel'])
    }
}